module.exports = __webpack_public_path__ + "img/1569620276.53d26448.jpg";